/**
 * tanium-custom.js
 * Add your custom JavaScript here.
 * This file is loaded on every page, after all theme scripts.
 */

// Populate enquiry cart textarea on /pages/cart-enquiry
if (window.location.pathname.replace(/\/$/, '') === '/pages/cart-enquiry') {
  console.log('[Tanium] Cart enquiry page detected');

  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      console.log('[Tanium] Item count:', cart.item_count);

      if (!cart.items.length) {
        console.log('[Tanium] Cart is empty, skipping');
        return;
      }

      const lines = cart.items.map((item) => {
        const variant = item.variant_title && item.variant_title !== 'Default Title'
          ? ` (${item.variant_title})`
          : '';
        return `${item.product_title}${variant} x${item.quantity}`;
      });

      const value = lines.join('\n');
      console.log('[Tanium] Formatted cart value:\n', value);

      function attachClearCartOnSubmit(shadowRoot, textarea) {
        const form = shadowRoot.querySelector('form');
        if (!form || form.dataset.clearCartAttached) return;
        form.dataset.clearCartAttached = 'true';
        // Capture phase runs before the framework's submit handler collects form data.
        // Re-apply the value here using the native setter so the framework's internal
        // state is updated before it reads the field.
        form.addEventListener('submit', () => {
          const nativeSetter = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set;
          nativeSetter.call(textarea, value);
          textarea.dispatchEvent(new Event('input', { bubbles: true }));
          fetch('/cart/clear.js', { method: 'POST' })
            .then(() => console.log('[Tanium] Cart cleared on enquiry submit'))
            .catch((err) => console.error('[Tanium] Failed to clear cart:', err));
        }, { capture: true });
      }

      function populateInShadow(shadowRoot) {
        const textarea = shadowRoot.querySelector('textarea[name="custom#enquiry_cart"]');
        console.log('[Tanium] Textarea in shadow root:', textarea);
        if (textarea) {
          textarea.value = value;
          console.log('[Tanium] Textarea populated successfully');
          attachClearCartOnSubmit(shadowRoot, textarea);
          return true;
        }
        return false;
      }

      function attachToEmbed(embed) {
        console.log('[Tanium] shopify-forms-embed found, shadow root:', embed.shadowRoot);
        if (!embed.shadowRoot) return;

        if (populateInShadow(embed.shadowRoot)) return;

        // Shadow root exists but textarea not yet rendered — observe inside it
        const shadowObserver = new MutationObserver(() => {
          if (populateInShadow(embed.shadowRoot)) {
            shadowObserver.disconnect();
          }
        });
        shadowObserver.observe(embed.shadowRoot, { childList: true, subtree: true });
      }

      const embed = document.querySelector('shopify-forms-embed');
      if (embed) {
        attachToEmbed(embed);
      } else {
        // Wait for shopify-forms-embed to appear in the DOM
        const bodyObserver = new MutationObserver(() => {
          const embed = document.querySelector('shopify-forms-embed');
          if (embed) {
            bodyObserver.disconnect();
            attachToEmbed(embed);
          }
        });
        bodyObserver.observe(document.body, { childList: true, subtree: true });
      }
    })
    .catch((err) => console.error('[Tanium] Failed to fetch cart:', err));
}
